import View         from 'scripts/poppet/view';
import template     from 'scripts/defa/zones/template-zone-alerts.jst.html';
import { T }        from 'defa-object';
import { Vue }      from 'vue/defavue';

/**
 * ZonePresetForm
 * A view for changing zone presets
 * @version 1.3.0
 */

const stripOptions     = [
	{ value: 'ON', 	title: T.tc( 'HomeAlert', 'On' ), 	titleContext: 'HomeAlert' },
	{ value: 'OFF', title: T.tc('HomeAlert', 'Off' ),	titleContext: 'HomeAlert' }
];

const channel = Bb.Radio.channel( 'objects' );
const channelNav = Bb.Radio.channel( 'nav' );

const ZoneAlertsForm = View.extend( {
	
	// ----------------------------------
	// setup
	// ----------------------------------
	
	template : template,
	className: 'card change-alert',
	
	
	onAttach: function(){
		this.attachSwitchesAndSliders();
	},
	

	// ----------------------------------
	// other functions
	// ----------------------------------
	
	attachSwitchesAndSliders: function() {
		let self   = this;
		new Vue({
			el: '#alert-components',
			
			bb() {
				return {
					heatingZoneModel: self.model.getModel( '5' )
				};
			},
			
			data() {
				return {
					stripOptions,
					lowTempAlertSwitchValue: 'OFF',
					highTempAlertSwitchValue: 'OFF',
					highTempSliderValue: 0,
					lowTempSliderValue: 0,
					absMaxTemperature: 40,
					absMinTemperature: -20,
					locked: !self.options.enabled,
				};
			},
			computed: {
				disableAlertSwitch: function () {
					return null === this.heatingZoneModel.alarmMask
				},
				
				disableLowTempSlider: function () {
					return null === this.heatingZoneModel.lowTempLevel
				},
				disableHighTempSlider: function () {
					return null === this.heatingZoneModel.highTempLevel
				},
			},

			methods: {
				saveAlarmMask() {
					let data = {};
					let lowTemp = 'ON' === this.lowTempAlertSwitchValue;
					let highTemp = 'ON' === this.highTempAlertSwitchValue;
					data.alarmMask = {
						lowTemp,
						highTemp
					};
					self.save(data)
				},
				
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= parseInt(newValue);
					self.save( data )
				},
				
				cancel() {
					self.trigger( 'cancel', self );
				},
			},
			
			watch: {
				'heatingZoneModel.alarmMask': function (newAttribute){
					this.lowTempAlertSwitchValue = newAttribute.lowTemp  ? 'ON' : 'OFF';
					this.highTempAlertSwitchValue = newAttribute.highTemp  ? 'ON' : 'OFF';
				},
				
				'heatingZoneModel.lowTempLevel': function (newAttribute){
					this.lowTempSliderValue = newAttribute;
				},
				
				'heatingZoneModel.highTempLevel': function (newAttribute){
					this.highTempSliderValue = newAttribute;
				}
			},
			
			created() {
				this.lowTempAlertSwitchValue = this.heatingZoneModel.alarmMask && this.heatingZoneModel.alarmMask.lowTemp ? 'ON' : 'OFF';
				this.highTempAlertSwitchValue = this.heatingZoneModel.alarmMask && this.heatingZoneModel.alarmMask.highTemp ? 'ON' : 'OFF';
				this.lowTempSliderValue = this.heatingZoneModel.lowTempLevel ? this.heatingZoneModel.lowTempLevel : 0;
				this.highTempSliderValue = this.heatingZoneModel.highTempLevel ? this.heatingZoneModel.highTempLevel : 0;
			}

		});
	},

	save: function(attrs) {
		let self = this;
		self.busy();
		try {
			this.model.getModel('5').save(attrs, {
				patch: true,
				isSaving: true,
				success: function() {
					console.log( Object.keys(attrs)[0] +' was succesfully saved!' );
					self.idle();
				},
				error: function(model, response) {
					console.error( Object.keys(attrs)[0] + ' failed saving with error: ' + response.responseJSON.message );
					self.idle();
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},

} );

export default ZoneAlertsForm;
